import { render, staticRenderFns } from "./SairSistema.vue?vue&type=template&id=defdc46a&"
import script from "./SairSistema.vue?vue&type=script&lang=js&"
export * from "./SairSistema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports